import { globalRegistry } from '../../services/globalRegistry';
import { useFeatureFlags } from '../../hooks/useFeatureFlags';
import { GlobalAppShell } from './GlobalAppShell';

export function GlobalApps() {
  const featureFlags = useFeatureFlags();

  const activeEntries = globalRegistry.filter(
    (entry) => !entry.featureFlagKey || !!featureFlags[entry.featureFlagKey]
  );

  return (
    <>
      {activeEntries.map((entry) => (
        <GlobalAppShell key={entry.id} entry={entry} />
      ))}
    </>
  );
}
